import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React, { useState } from 'react';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import {
  Accordion,
  AccordionProps,
} from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import PeopleSectionController from 'src/components/oneCorp/features/MealCredit/components/People/PeopleSectionController';

interface PeopleAccordionProps extends Omit<AccordionProps, 'header' | 'body'> {
  mealCredit: IMealCredit;
  corpId: string;
  fetchMealCredit: () => Promise<void>;
}

export function PeopleAccordion({
  mealCredit,
  corpId,
  fetchMealCredit,
  ...props
}: PeopleAccordionProps): JSX.Element {
  const [peopleCount, setPeopleCount] = useState<number>(0);

  return (
    <Stack y="md" bg="globals.white">
      <Accordion
        {...props}
        header={(): JSX.Element => (
          <Heading variant="h6">People ({peopleCount})</Heading>
        )}
        body={(): JSX.Element => (
          <PeopleSectionController
            corpId={corpId}
            mealCreditId={mealCredit.id}
            tagInvites={mealCredit.tag_invites}
            onAssignAllowanceAmount={fetchMealCredit}
            onTotalResultsChange={(count: number): void =>
              setPeopleCount(count)
            }
          />
        )}
      />
    </Stack>
  );
}
